import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=0055286e&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageMainScalableImageInner: require('/usr/src/motec/components/page/main/ScalableImageInner.vue').default,PageMainImageInner: require('/usr/src/motec/components/page/main/ImageInner.vue').default})
